import { Flex } from 'antd';

import {
  $ArithmeticOperation,
  $JtfMode,
  ArithmeticOperation,
  FactStatus,
  JtfMode,
} from '@suntex.fim/enums';

import * as images from '../assets/images';

import './JTFPlayerGraph.scss';
import { jtfData } from './const';
import { getCellLabel } from './getCellLabel';

interface PlayerGraphProps {
  jtfProgress: FactStatus[][];
  mode: JtfMode;
  operation: ArithmeticOperation; // now receiving the selected operator object
}

export function JTFPlayerGraph({
  jtfProgress,
  mode,
  operation,
}: PlayerGraphProps) {
  const modeDesc = $JtfMode.describe(mode);
  const operatorDesc = $ArithmeticOperation.describe(operation);

  const modeData = jtfData[modeDesc.slug];
  const operationData = modeData[operatorDesc.slug];

  const leftProblems = operationData.left;
  const rightProblems = operationData.right;

  return (
    <Flex vertical className="jtf-player-graph">
      <Flex gap={10} align="center" className="jtf-player-graph__header">
        <Flex gap={10} align="center">
          <div className="legend-box correct">
            <images.CheckboxCheckedGreen />
          </div>
          <p>Correct</p>
        </Flex>
        <Flex gap={10} align="center">
          <div className="legend-box incorrect">
            <images.CheckboxCrossRed />
          </div>
          <p>Incorrect</p>
        </Flex>
        <Flex gap={10} align="center">
          <div className="legend-box incomplete">
            <images.OutlineTime />
          </div>
          <p>Incomplete</p>
        </Flex>
      </Flex>

      <div className="jtf-player-graph__grid">
        {jtfProgress.map((row, rowIndex) => {
          // Helper function to get cell class
          const getCellClass = (value: FactStatus): string => {
            if (value === FactStatus.Correct) return 'correct';
            if (value === FactStatus.Incorrect) return 'incorrect';
            return 'incomplete';
          };

          return row.map((value, colIndex) => {
            const cellClass = getCellClass(value);
            const label = getCellLabel(
              rowIndex,
              colIndex,
              operation,
              mode,
              leftProblems,
              rightProblems,
              operatorDesc.symbol,
            );
            const cellKey = `cell-${rowIndex}-${colIndex}-${value}`;

            // Render appropriate icon based on value
            const renderIcon = () => {
              switch (value) {
                case FactStatus.Correct:
                  return <images.CheckboxCheckedGreen />;
                case FactStatus.Incorrect:
                  return <images.CheckboxCrossRed />;
                case FactStatus.Incomplete:
                  return <images.OutlineTime />;
                default:
                  return null;
              }
            };

            return (
              <div
                className={`jtf-player-graph__cell ${cellClass}`}
                key={cellKey}
                aria-label={`Cell at row ${rowIndex + 1}, column ${colIndex + 1}`}
              >
                <span className="jtf-player-graph__fact">{label}</span>
                <div className="player-checkbox">{renderIcon()}</div>
              </div>
            );
          });
        })}
      </div>
    </Flex>
  );
}
